import { PERMISSION_LEVELS } from '@src/const';
import { AlertTypes } from '@src/constants/MogamboConstants';
import {
  createAlert,
  showConfirmationDialog,
  userHasPermission,
  permissionErrorAlert,
} from '@src/actions/BotActions';
import { getBusinessDataEditStatus } from '../store/selectors';
import BusinessStore from '../store';

export function canTransfer(transferGroups, tasks = []) {
  const state = BusinessStore.getState();
  if (getBusinessDataEditStatus(state)) {
    createAlert('Please save the changes before publishing');
    return false;
  }

  if (
    transferGroups.indexOf('business') !== -1 ||
    transferGroups.indexOf('task') !== -1
  ) {
    // Verify Business/Task transfer checks
    if (!userHasPermission(PERMISSION_LEVELS.BUSINESS_TASK_EDIT_TRANSFER)) {
      permissionErrorAlert('publish Business Task');
      return false;
    }
  }

  if (transferGroups.indexOf('trigger') !== -1) {
    // Verify trigger transfer checks
    if (
      !userHasPermission(
        PERMISSION_LEVELS.BUSINESS_PROMPT_TRIGGER_EDIT_TRANSFER
      )
    ) {
      permissionErrorAlert('publish bot prompt triggers');
      return false;
    }
  }

  if (transferGroups.indexOf('task') !== -1 && tasks.length === 0) {
    createAlert(
      'There are no tasks to be published',
      null,
      AlertTypes.NEGATIVE
    );
    return false;
  }

  return true;
}

export function transfer(
  { title, message, success, error, errors, activateLoader, deactivateLoader },
  apiCalls
) {
  showConfirmationDialog({
    title,
    message,
    okTitle: 'Publish ',
    cancelTitle: 'Cancel',
    onOk: async () => {
      activateLoader();
      const response = await Promise.all(
        apiCalls.map((call) => {
          const headers = call.headers || {};
          return call.api(...call.params, headers);
        })
      );

      if (response && Array.isArray(response)) {
        response.forEach((responseItem, i) => {
          if (!responseItem) {
            // if multiple errors are present, show according to index
            // otherwise show just single error
            const errorToDisplay = errors ? errors[i] : error;
            createAlert(errorToDisplay, null, AlertTypes.NEGATIVE);
          } else createAlert(success, null, AlertTypes.POSITIVE);
        });
      } else if (response) {
        createAlert(success, null, AlertTypes.POSITIVE);
      } else {
        createAlert(error, null, AlertTypes.NEGATIVE);
      }

      deactivateLoader();
    },
    onCancel: () => {},
  });
}
